import './Competitions.css';
import { useEffect } from 'react';
import competitionImg from './IMAGE/COMPETITION.jpeg';

function Competitions({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const competitions = [
    {
      name: "Best Research & Prototype",
      org: "FAITH Colleges",
      date: "2026",
      role: "Team Member / Presenter",
      tag: "Award",
      tagType: "award",
      dotColor: "#667eea",
      desc: "Participated in an inter-departmental collaborative project presentation and prototype exhibition at FAITH Colleges. Showcased innovative engineering solutions and demonstrated technical prototypes to faculty and industry professionals."
    },
    {
      name: "Press Conference — Sports Writing",
      org: "Division",
      date: "2016",
      role: "Competitor / Writer",
      tag: "Champion",
      tagType: "champion",
      dotColor: "#27ae60",
      desc: "Competed against writers from across the division. Secured the top spot for demonstrating precise, analytical, and engaging coverage of sporting events under extreme time pressure."
    },
    {
      name: "Regional Press Conference — Sports Writing",
      org: "DepEd Lipa Division",
      date: "2016",
      role: "Division Representative",
      tag: "2nd Place",
      tagType: "award",
      dotColor: "#e67e22",
      desc: "Represented the DepEd Lipa Division at the regional level. Showcased strong journalistic prowess and ability to adapt to complex sports scenarios, finishing among the top tier competitors."
    }
  ];

  const legend = [
    { label: "Awards", color: "#667eea" },
    { label: "Competition", color: "#e67e22" },
    { label: "Champion", color: "#27ae60" },
  ];

  return (
    <div className="comp-page">
      {/* ── Hero Strip ── */}
      <div className="comp-hero-strip">
        <div className="comp-strip-inner">
          <p className="comp-strip-label">Events & Challenges</p>
          <h1 className="comp-strip-name">Competitions</h1>
          <p className="comp-strip-role">A showcase of competitive events I have participated in.</p>
          <div className="hero-stats-row">
            <span className="hero-stat-pill">▸ 3 Major Events</span>
            <span className="hero-stat-pill">▸ Sports Writing</span>
            <span className="hero-stat-pill">▸ Champion — Division Level</span>
          </div>
          <div className="hero-watermark">◈</div>
        </div>
      </div>

      {/* ── Main Content: Timeline ── */}
      <main className="comp-main">
        {/* ── Certificate Showcase ── */}
        <div className="comp-cert-showcase">
          <div className="comp-cert-preview">
            <img src={competitionImg} alt="Best Research & Prototype Certificate" className="comp-cert-img" />
          </div>
          <div className="comp-cert-info">
            <span className="comp-cert-badge">🏆 Top Award</span>
            <h3>Best Research & Prototype</h3>
            <p>Collaborative Project Presentation and Prototype Exhibition · FAITH Colleges · April 2026</p>
          </div>
        </div>

        {/* ── Timeline ── */}
        <div className="comp-timeline">
          {competitions.map((comp, idx) => (
            <div className="tl-item" key={idx}>
              <div className="tl-dot-area">
                <span className="tl-dot" style={{ background: comp.dotColor }}></span>
                {idx < competitions.length - 1 && <span className="tl-line"></span>}
              </div>
              <div className="tl-card">
                <p className="tl-meta">{comp.date} · {comp.org}</p>
                <h3 className="tl-name">{comp.name}</h3>
                <p className="tl-role">{comp.role}</p>
                <span className={`tl-tag tl-tag--${comp.tagType}`}>{comp.tag}</span>
                <p className="tl-desc">{comp.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* ── Legend ── */}
        <div className="tl-legend">
          {legend.map((l, i) => (
            <span className="tl-legend-item" key={i}>
              <span className="tl-legend-dot" style={{ background: l.color }}></span>
              {l.label}
            </span>
          ))}
        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="comp-footer">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="comp-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>
    </div>
  );
}

export default Competitions;
